import type { IconData } from '@stacksjs/iconify-core'

export const basicUiHome: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M.16 8.49L8 .65l7.84 7.84v6.86H.16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiHome
